"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const theme_tools_1 = require("@chakra-ui/theme-tools");
const utils_1 = require("@chakra-ui/utils");
const $bg = (0, theme_tools_1.cssVar)('tooltip-bg');
const $color = (0, theme_tools_1.cssVar)('tooltip-color');
const $arrowBg = (0, theme_tools_1.cssVar)('popper-arrow-bg');
const baseStyle = () => {
    const bg = 'purple.400';
    const color = 'white';
    return {
        [$bg.variable]: `colors.${bg}`,
        px: '8px',
        py: '2px',
        bg: [$bg.reference],
        [$arrowBg.variable]: [$bg.reference],
        color,
        borderRadius: 'sm',
        fontWeight: 'medium',
        fontSize: 'sm',
        boxShadow: '2xl',
        maxW: '320px',
        zIndex: 'tooltip',
    };
};
const variantLight = props => (0, utils_1.mergeWith)({}, props.theme.components.Tooltip.variants.light, {
    [$bg.variable]: 'colors.lilac.50',
    [$color.variable]: 'colors.purple.400',
    bg: [$bg.reference],
    color: [$color.reference],
    [$arrowBg.variable]: [$bg.reference],
    borderRadius: 4,
    p: 4,
    pointerEvents: 'all',
    position: 'relative',
});
const variantDark = props => (0, utils_1.mergeWith)({}, props.theme.components.Tooltip.variants.dark, {
    [$bg.variable]: 'colors.purple.400',
    bg: [$bg.reference],
    [$arrowBg.variable]: [$bg.reference],
    borderRadius: 4,
    p: 4,
    pointerEvents: 'all',
    position: 'relative',
});
const variants = {
    light: variantLight,
    dark: variantDark,
};
const defaultProps = {
    variant: 'dark',
};
const TooltipStyles = {
    baseStyle,
    variants,
    defaultProps,
};
exports.default = TooltipStyles;
